<template>
    <div>
        <page-title-bar></page-title-bar>
        <phieu-sua-chua @onDialogRepairTimesheetSubmitted="handleDialogRepairTimesheetSubmitted"/>
        <tho-sua-chua type="monthly"/>
        <cham-cong :reloadRepairTimesheetTable="reloadRepairTimesheetTable"/>
    </div>
</template>

<script>

import ChamCong from "./ChamCong.vue";
import PhieuSuaChua from "./PhieuSuaChua.vue";
import ThoSuaChua from "../ThoSuaChua/ThoSuaChua.vue"

export default {
    name: "phieu-sua-chua-va-cham-cong-layout",
    components: {
        ChamCong,
        PhieuSuaChua,
        ThoSuaChua
    },
    data() {
        return {
            reloadRepairTimesheetTable: 0
        }
    },
    methods: {
        handleDialogRepairTimesheetSubmitted() {
            this.reloadRepairTimesheetTable++;
        }
    }
}
</script>

<style></style>